import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import type { ExportButtonContainerProps } from './ExportMapButton.types';

export const ExportButtonContainer = styled(Box)<ExportButtonContainerProps>`
  width: 42px;
  height: 32px;
  padding: 0 8px;
  background-color: ${({ theme }) => theme.colors.background};
  border-left: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  transition: all 0.2s ease;
  cursor: pointer;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${({ theme }) =>
      theme.colors.hoverBackground || theme.colors.background};
  }
`;
